import {call, put, takeLatest} from 'redux-saga/effects';
import RewardsTop10GamesApi from '../../api/RewardsTop10GamesApi';
import rewardsTop10GamesActions from '../../actions/fortnite-game/rewardsTop10Games.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getRewardsTop10Games(action) {
    try {
        delete action.payload.silent;

        const {data} = yield call(RewardsTop10GamesApi.getData, action.payload);

        yield put(
            rewardsTop10GamesActions.getRewardsTop10GamesSuccess({
                data,
                error: data && data.length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(
            rewardsTop10GamesActions.getRewardsTop10GamesFailed(getErrorCodeFromResponse(e), e)
        );
    }
}

function* rewardsTop10GamesSaga() {
    yield takeLatest(rewardsTop10GamesActions.TYPES.GET_REWARDS_TOP_10_GAMES, getRewardsTop10Games);
}

export default rewardsTop10GamesSaga;
